import { type Observable, interval, merge } from 'rxjs'
import { type Member } from './Member'
import { switchMap, map, retry, takeUntil } from 'rxjs/operators'

/**
 * Calls `updateLastSeen` and `updateLastLogin` when appropriate.
 *
 * @param currentMember$
 * @param loggedOut$
 * @param updateLastLogin
 * @param updateLastSeen
 * @param updateLastSeenInterval
 */
export function lastSeenSync(
  currentMember$: Observable<Member>,
  loggedOut$: Observable<unknown>,
  updateLastLogin: (member: Member) => Promise<unknown>,
  updateLastSeen: (member: Member) => Promise<unknown>,
  /* istanbul ignore next */
  updateLastSeenInterval = 120000,
) {
  return merge(
    currentMember$.pipe(
      takeUntil(loggedOut$),
      switchMap((m) => updateLastLogin(m)),
      retry({ resetOnSuccess: true, delay: 5_000, count: 10 }),
    ),
    currentMember$.pipe(
      // Whenever a workspace gets selected, start a timer (and stop the previous one).
      // When the timer elapses, emit the current member.
      switchMap((member) =>
        interval(updateLastSeenInterval).pipe(map(() => member)),
      ),
      takeUntil(loggedOut$),
      switchMap((m) => updateLastSeen(m)),
      retry({ resetOnSuccess: true, delay: 5_000, count: 10 }),
    ),
  )
}
